<div class="welcome-nav" [class.hidden]="!navbarVisible && !menuSliderLeft">
  <div class="text-center text-white my-auto d-flex justify-content-center">
    <i class="fa-solid fa-bullhorn my-auto mr-2"></i>
    <p>{{ messageAtTop?.trim() }}</p> <!--Used to be grow to kachiing-->
  </div>
</div>
<nav class="bg" [class.hidden]="!navbarVisible && !menuSliderLeft" style="z-index: 1001">
  <!--left side is covering and making the close button not clicckable-->
  <div class="container-fluid">
    <div class="left" [class.text-white]="menuSliderLeft">
      <span class="hamburger-icon menu-button" [class.icon-close]="menuSliderLeft"
        (click)="$event.stopPropagation(); menuSliderLeft = !menuSliderLeft">
        <span></span>
        <span></span>
        <span></span>
      </span>
      <a routerLink="/" class="logo">
        <svg viewBox="0 0 127 122" fill="none">
          <path
            d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z" />
          <path
            d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z" />
          <path
            d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z" />
          <path
            d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z" />
          <path
            d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z" />
        </svg>
        <div class="logo--content">
          <div class="logo--content__beta">BETA</div>
          <div class="logo--content__title">Kachiing</div>
          <div class="logo--content__desc">{{ sloganText }}</div>
        </div>
      </a>
    </div>
    <ul class="links">
      <li>
        <a id="suggestion-shepherd" routerLinkActive="active"
          [routerLink]="isUserLogin == 1 && roleService.roles?.level?.includes('MEMBER_VERIFIED_USER') ? '/community/me/nearby' : '/community'">My
          Community</a>
      </li>
      <li>
        <a routerLinkActive="active" routerLink="/faq">FAQ</a>
        <!-- <a routerLinkActive="active" routerLink="/biz">KachiingBiz</a> -->
      </li>
      <li>
        <a routerLinkActive="active" routerLink="/news">Share News</a>
      </li>
      <li>
        <a routerLinkActive="active" routerLink="/forum">Forum</a>
      </li>
    </ul>
    <ul class="icons">
      <li class="d-md-none d-block" *ngIf="isUserLogin == 1">
        <span class="icon" (click)="openProfilePopup('profileCharacter')">
          <i class="fa-solid fa-bolt"></i>
        </span>
      </li>

      <ng-container *ngIf="isUserLogin === 0; else loggedIn">
        <li id="loginBtn" class="d-flex justify-content-center align-items-center" style="cursor: pointer"
          (click)="openSigninModal()">
          <!-- <i class="fa-solid fa-sign-in-alt" id="loginBtn" ></i>  -->
          <span style="color: white; font-size: 1.2rem" class="ml-2">Login</span>
        </li>
      </ng-container>
      <ng-template #loggedIn>
        <li class="d-none d-md-block search-info">
          <i class="fa-solid fa-search" routerLink="/community/me/search"></i>
        </li>
        <li *ngIf="isUserLogin == 1" class="chat-info" style="position: relative">
          <i class="fa fa-circle comment-icon" *ngIf="isNewMessage" style="top: 2.8em !important"></i>
          <i (click)="openProfilePopup('chat')" class="fa-solid fa-comments" style="position: relative">
            <!--PLEASE ACCEPT CHANGES HERE-->
            <span *ngIf="totalUnreadMessagesCount"
              style="color: white; font-size: 11px; font-weight: bold; top: -5px; position: absolute; left: 1.5em">{{
              totalUnreadMessagesCount }}</span>
          </i>
        </li>
        <li *ngIf="isUserLogin == 1">
          <notification></notification>
        </li>
      </ng-template>
      <li class="dropdown">
        <a class="dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-circle-chevron-down"></i>
        </a>
        <div class="dropdown-menu px-1" aria-labelledby="navbarDropdown">
          <!-- <a (click)="openProfilePopup('profileCharacter')" class="dropdown-item profile-info" style="color: var(--primary) !important" *ngIf="isUserLogin == 1"> <i style="color: var(--primary) !important" class="fa-solid fa-bolt"></i> Quickbar </a> -->
          <a routerLinkActive="active" routerLink="/advanced-settings" *ngIf="isUserLogin == 1" class="dropdown-item"
            style="color: var(--primary) !important"> <i style="color: var(--primary) !important"
              class="fa-solid fa-gear"></i> Settings </a>
          <a (click)="openShopSignoutPopup(shopSignoutPopup)" class="dropdown-item"
            style="color: var(--primary) !important" *ngIf="isUserLogin == 1"> <i
              style="color: var(--primary) !important" class="fa-solid fa-right-from-bracket"></i> Log Out </a>
        </div>
      </li>
    </ul>
  </div>
</nav>

<div class="nav-top-mobile" style="z-index: 1001;">
  <div class="left">
    <span class="hamburger-icon menu-button" [class.icon-close]="menuSliderLeft"
      (click)="$event.stopPropagation(); menuSliderLeft = !menuSliderLeft">
      <span></span>
      <span></span>
      <span></span>
    </span>
    <a class="logo" routerLink="/">
      <svg viewBox="0 0 127 122" fill="none">
        <path
          d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z" />
        <path
          d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z" />
        <path
          d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z" />
        <path
          d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z" />
        <path
          d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z" />
      </svg>
      <div class="logo--content">
        <div class="logo--content__beta">BETA</div>
        <div class="logo--content__title">Kachiing</div>
        <div class="logo--content__desc">{{ sloganText }}</div>
      </div>
    </a>
  </div>
  <ul>
    <ng-container *ngIf="isUserLogin === 0; else loggedIn">
      <!-- <li>
         <i class="fa-solid fa-sign-in-alt" id="loginBtn" (click)="openSigninModal()"></i> 
        
      </li> -->
      <li class="d-flex justify-content-center align-items-center" style="cursor: pointer" id="loginBtn"
        (click)="openSigninModal()">
        <!-- <i class="fa-solid fa-sign-in-alt" id="loginBtn" ></i>  -->
        <span style="color: white; font-size: 1.2rem" class="ml-2">Login</span>
      </li>
    </ng-container>
    <li class="dropdown d-md-none d-block">
      <a class="dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fas fa-circle-chevron-down"></i>
      </a>
      <div class="dropdown-menu px-1" aria-labelledby="navbarDropdown">
        <a (click)="openProfilePopup('profileCharacter')" class="dropdown-item profile-info"
          style="color: var(--primary) !important" *ngIf="isUserLogin == 1"> <i style="color: var(--primary) !important"
            class="fa-solid fa-bolt"></i> Quickbar </a>
        <a routerLinkActive="active" routerLink="/community/me/search" class="dropdown-item"
          style="color: var(--primary) !important"> <i style="color: var(--primary) !important"
            class="fa-solid fa-search"></i> Search </a>
        <!-- <a routerLinkActive="active" routerLink="/faq" class="dropdown-item"
          style="color: var(--primary) !important;">
          <i style="color: var(--primary) !important;" class="fa-solid fa-circle-question"></i> FAQ
        </a> -->
        <a routerLinkActive="active" routerLink="/advanced-settings" *ngIf="isUserLogin == 1" class="dropdown-item"
          style="color: var(--primary) !important"> <i style="color: var(--primary) !important"
            class="fa-solid fa-gear"></i> Settings </a>
        <a (click)="openShopSignoutPopup(shopSignoutPopup)" class="dropdown-item"
          style="color: var(--primary) !important" *ngIf="isUserLogin == 1"> <i style="color: var(--primary) !important"
            class="fa-solid fa-right-from-bracket"></i> Log Out </a>
      </div>
    </li>
    <!-- <li *ngIf="isUserLogin == 1" style="position: relative">
      <i class="fa fa-circle comment-icon" *ngIf="isNewMessage"></i>
      <i (click)="openProfilePopup('chat')" class="fa-solid fa-comments">
        <span *ngIf="totalUnreadMessagesCount > 0"
          style="color: deeppink; font-size: 12px; font-weight: bold; margin-left: 3px">{{ totalUnreadMessagesCount
          }}</span>
      </i>
    </li> -->

    <ng-template #loggedIn>
      <li>
        <notification></notification>
      </li>
      <li>
        <i class="fa-solid fa-right-from-bracket" (click)="openShopSignoutPopup(shopSignoutPopup)"></i>
      </li>
    </ng-template>
  </ul>
</div>
<app-side-left-menu #sideLeftMenu [menuSliderLeft]="menuSliderLeft"
  (menuSliderLeftChange)="menuSliderLeft = $event"></app-side-left-menu>
@if (isUserLogin === 1) {
<marketplace-profile #MarketplaceProfile></marketplace-profile>
}
<div class="main">
  <router-outlet></router-outlet>
</div>
<app-common-footer></app-common-footer>
@if(isUserLogin === 1) {
<div class="nav-mobile">
  <a routerLinkActive="active" [routerLink]="'/community/search'" (click)="closeMenus('search')"
    [ngClass]="{ active: marketplaceProfileSection?.showProfileMenu !== true && currentMenu == 'search' }">
    <div>
      <i class="fa-solid fa-search"></i>
      <div class="text">Search</div>
    </div>
  </a>
  <a routerLinkActive="active" routerLink="/community/me/nearby" (click)="closeMenus('nearBy')"
    [ngClass]="{ active: marketplaceProfileSection?.showProfileMenu != true && currentMenu == 'nearBy' }">
    <div>
      <i class="fa-solid fa-compass"></i>
      <div class="text">Nearby</div>
    </div>
  </a>
  <a class="center" routerLinkActive="my-active" routerLink="/community/me/list" (click)="closeMenus('list')"
    [ngClass]="{ active: marketplaceProfileSection?.showProfileMenu != true && currentMenu == 'list' }">
    <div class="circle">
      <i class="fa-sharp fa-solid fa-plus"></i>
    </div>
    <svg viewBox="0 0 96 127" fill="none">
      <path
        d="M16 13C16 1 8.5 1 1 1V125.5H95.5V1C88 1 80.5 1 80.5 13C80.5 25.4478 68.1041 45.3332 48.25 45.499C28.3959 45.3332 16 25.4478 16 13Z" />
    </svg>
    <div class="name">List</div>
  </a>
  <a routerLinkActive="active" (click)="closeMenus('profile')"
    [ngClass]="{ active: marketplaceProfileSection?.showProfileMenu != true && currentMenu == 'profile' }"
    [routerLink]="['/community/profile', referralCode]">
    <div>
      <i class="fa-regular fa-user"></i>
      <div class="text">Profile</div>
    </div>
  </a>

  <a style="position: relative" (click)="openProfilePopup('chat')"
    [ngClass]="{ active: marketplaceProfileSection?.showProfileMenu == true }">
    <div>
      <i class="fa-solid fa-comments">
        <span *ngIf="totalUnreadMessagesCount > 0"
          style="color: deeppink; font-size: 12px; font-weight: bold; margin-left: 3px">{{ totalUnreadMessagesCount
          }}</span>
      </i>
      <div class="text">Chat</div>
    </div>
  </a>
</div>
}

@if(isUserLogin && isUserLogin != '0'){
<div class="floating-menu">
  <div class="chat-bubble-product-details shadow d-flex flex-column justify-content-start align-items-center p-4"
    *ngIf="showExplainerParam2 && showProductExplainer && explainText">
    <button class="close-btn" (click)="closeExplainerUntilNextProduct()"><i class="fa fa-x"></i></button>
    <span>{{explainText}}</span>
    <div class="btns d-flex justify-content-center mt-2">
      <button class="mr-4" (click)="openRefer()" *ngIf="isExplanationProductClaimable">Refer a friend</button>
      <button (click)="openAddExperience()">Add an experience</button>
    </div>

  </div>
  <div class="bars" style="transform: scaleX(-1);"
    (click)="showProductExplanation ? showExplainerParam2 = true : openMenuOptionsModal(menuOptions)"
    [class.dominant-wizard]="explainText">
    <img loading="lazy" src="../../../../../assets/images/w.jpeg" alt="" />

  </div>
</div>

}@else if(isOnBrowser && isWizardVisisble){
<!--Modal will block this it cause z-index of it is 999-->
<div class="floating-menu logout-wiz" style="position: relative; z-index: 1051;">
  <div class="chat-bubble-product-details 
     shadow d-flex flex-column justify-content-start align-items-center p-4"
    *ngIf="showExplainerParam2 && showProductExplainer && explainText"
    style="position: fixed;z-index: 998;bottom: 9em; left: 1em;">
    <button class="close-btn" (click)="closeExplainerUntilNextProduct()"><i class="fa fa-x"></i></button>
    <span>{{explainText}}</span>
    <div class="btns d-flex justify-content-center mt-2">
      <button class="mr-4" (click)="clickLogin()">Refer a friend</button>
      <button (click)="clickLogin()">Add an experience</button>
    </div>
    <div class="btns d-flex justify-content-center mt-2">
      <button class="mr-4" (click)="isWizardVisisble = false">Hide wizard</button>
      <button *ngIf="isPopupOpen" (click)="isUserLogin ? editCurrentProduct() : clickLogin()">Edit Product</button>
    </div>


  </div>
  <div *ngIf="selectedMobileAd" class="chat-bubble shadow  mobile-ad"
    style="position: fixed;z-index: 998;bottom: 8em; left: 1em; border: 1px solid var(--secondary); ">
    <img [src]="imgUrl+ selectedMobileAd.imageLocation" class="shadow" />
  </div>
  <div class="bars " style="left: 0px;"
    [class.dominant-wizard]="explainText || (mobileAds.length && !showProductExplanation && !isMobile && glowMobileAds)">
    <div style="position: relative;" (click)="showExplainerParam2 = true; showMobileAd()">

      <img [class.shadow-lg]="mobileAds.length" [class.giggle]="giggleWiz" loading="lazy"
        src="../../../../../assets/images/w.jpeg" alt="" />



    </div>

  </div>


</div>



}


<div class="quickbar" (click)="openProfilePopup('profileCharacter')" *ngIf="isUserLogin == 1">
  <i style="color: var(--primary) !important" class="fa-solid fa-bolt"></i>
</div>
<ng-template #menuOptions let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body min-height-menu">
    @if(tabMenu === 0) {
    <ul>
      <!-- <li *ngIf="isUserLogin == 1" [routerLink]="['/community/profile', referralCode]">
        <i class="fa-solid fa-user icon-bar"></i>
        <div class="name">Profile</div>
      </li> -->
      <li *ngIf="isUserLogin == 1" class="desktop" [routerLink]="['/community/me/list']">
        <i class="fa-solid fa-dollar-sign icon-bar"></i>
        <div class="name">Sell</div>
      </li>
      <!-- <li (click)="goTo('/advanced-settings')" *ngIf="isUserLogin == 1">
        <i class="fa-solid fa-gear icon-bar"></i>
        <div class="name">settings</div>
      </li> -->
      <!-- <li *ngIf="isUserLogin == 1" class="desktop" (click)="tabMenu = 2">
        <i class="fa-solid fa-robot icon-bar"></i>
        <div class="name">Bot</div>
      </li> -->
      <li *ngIf="isUserLogin == 1" [ngClass]="{
          desktop: true,
          'glow-notification': areThereNewMessages
        }" (click)="openProfilePopup('chat')">
        <i class="fa-solid fa-comments icon-bar"></i>
        <div class="name">chat</div>
      </li>
      <li (click)="tabMenu = 1" class="glow-notification">
        <i class="fa-solid fa-clipboard-list icon-bar"></i>
        <div class="name">survey</div>
      </li>
      <li (click)="openAIChat()">
        <i class="fa-solid fa-robot icon-bar"></i>
        <div class="name">AI Bot</div>
      </li>
      <li (click)="goToGiveAway()">
        <i class="fa-solid fa-gift icon-bar"></i>
        <div class="name">Giveaway</div>
      </li>

      <li *ngIf="isUserLogin" class="desktop">
        <online-toggle-button></online-toggle-button>
        <div class="name">online</div>
      </li>
      <li *ngIf="isUserLogin" (click)="handleReport()">
        <i class="fa-solid fa-exclamation icon-bar"></i>
        <div class="name">report</div>
      </li>
    </ul>
    } @else {
    <div class="menu-2__back" (click)="tabMenu = 0"><i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i>
      Back</div>
    }

    <div class="menu-2__content">
      @if(tabMenu === 1) {
      <app-survey></app-survey>
      } @else if(tabMenu === 2) {
      <div class="px-3">
        <div class="under-maintenance">
          <i class="fa-solid fa-tools icon-bar"></i>
          <div class="name">Under Maintenance</div>
        </div>
      </div>
      }
    </div>
  </div>
</ng-template>

<app-diamonds-popup></app-diamonds-popup>
<app-sign-in #SignIn></app-sign-in>

<ng-template #shopSignoutPopup let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="">
            <h2 class="cart_title mb-2">Are you sure ?</h2>
            <p class="text-center">You want to logout from the website.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="cart_btn mt-4">
            <a (click)="logout()" class="confirm_button">Yes </a>
            <a (click)="modalDismissAll()" class="confirm_button">No </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- end popup -->